// extracted by css-extract-rspack-plugin
export default {"description":"SharedHeader-module__description__W3MeG","PreviewLabel":"SharedHeader-module__PreviewLabel__Xhvjv"};